import { TOption, TradingPlatForms } from '@src/types';
import { TExchangePackagesTable } from '@src/types/exchangePackages.ts';

export const platformRadioData: TOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Rithmic', value: TradingPlatForms.RITHMIC_DATA_FEED },
  // { label: 'dxFeed', value: TradingPlatForms.DX_DATA_FEED }, // Commented out
  // { label: 'Tradovate', value: TradingPlatForms.CQG_DATA_FEED }, // Commented out
];

export const categoryRadioData: TOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Trading Products', value: 'tradingProducts' },
  { label: 'Market Data', value: 'marketData' },
  { label: 'Addons', value: 'addons' },
  { label: 'Reset', value: 'reset' },
  { label: 'Others', value: 'others' },
];

export const packageTypeCheckboxData: TOption[] = [
  { label: 'Is Rithmic Package?', value: 'rithmic' },
  // { label: 'Is DxFeed Package?', value: 'dxFeed' }, // Commented out
  // { label: 'Is Tradovate Package?', value: 'tradovate' }, // Commented out
];

export const addonTypeCheckboxData: TOption[] = [
  { label: 'Visible on leelootrading.com?', value: 'visible' },
  { label: 'Active for MINT processing?', value: 'active' },
  { label: 'Is this a PA subscription?', value: 'subscription' },
  { label: 'Is recurring?', value: 'recurring' },
  { label: 'Allow Resets?', value: 'resets' },
  { label: 'Is this a downloadable purchase (eg. video)?', value: 'purchase' },
  { label: 'Is this a competition product?', value: 'competition' },
  { label: 'Is this limited Payout Product?', value: 'limited' },
  { label: 'Is this weekly payout product ?', value: 'weekly' },
];

export const demoTypeRadioData: TOption[] = [
  { label: 'No', value: 'no' },
  { label: 'Demo ', value: 'demo ' },
  { label: 'Bundle (Only 1 can qualify)', value: 'bundle' },
];

export const commissionPercentageCheckboxData: TOption[] = [
  { label: 'Feature 1', value: 'feature1' },
  { label: 'Feature 2', value: 'feature2' },
  { label: 'Feature 3', value: 'feature3' },
  { label: 'Feature 4', value: 'feature4' },
];

export const categoryData: TOption[] = [
  { label: 'Feature 1', value: 'feature1' },
  { label: 'Feature 2', value: 'feature2' },
  { label: 'Feature 3', value: 'feature3' },
  { label: 'Feature 4', value: 'feature4' },
];

export const exchangeDataTable: TExchangePackagesTable[] = [
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
  {
    id: '1',
    name: 'Static Competition ES, NQ, YM Q contract | 10 micros Each',
    category: 'Trading - Futures',
    platform: 'Rithmic',
    visibleOnWebsite: true,
    activeMintProcessing: true,
  },
];
